// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-vuo0z";
var _5 = "insurances-2obuI";
var _6 = "header-2-X1W";
var _7 = "dialog-Xk7w4";
var _8 = "dialog__header-1rI4l";
var _9 = "rules-2V8co";
var _a = "controls-H_ljI";
var _b = "buttons-1LUnf";
var _c = "documents-2APzL";
var _d = "mobileWrapper-epOge";
var _e = "dialog__button_done-2fW0N";
var _f = "dialog__button_clear-bwlMD";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "insurances", _6 as "header", _7 as "dialog", _8 as "dialog__header", _9 as "rules", _a as "controls", _b as "buttons", _c as "documents", _d as "mobileWrapper", _e as "dialog__button_done", _f as "dialog__button_clear" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "insurances": _5, "header": _6, "dialog": _7, "dialog__header": _8, "rules": _9, "controls": _a, "buttons": _b, "documents": _c, "mobileWrapper": _d, "dialog__button_done": _e, "dialog__button_clear": _f }
